import { shallowEqual } from 'react-redux';
import { useTypedSelector } from '../hooks';

export function useSelectError() {
  return useTypedSelector(({ alerts }) => alerts.error, shallowEqual);
}
export function useSelectSnackBar() {
  return useTypedSelector(({ alerts }) => alerts.snackbar, shallowEqual);
}
